'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _Component2 = require('../../Component');

var _Component3 = _interopRequireDefault(_Component2);

var _main = require('../templates/main');

var _main2 = _interopRequireDefault(_main);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _theme = require('../../theme');

var _theme2 = _interopRequireDefault(_theme);

var _getScrollWidth = require('../../../utils/getScrollWidth');

var _getScrollWidth2 = _interopRequireDefault(_getScrollWidth);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var iosPattern = /iPhone|iPad/,
    iosVersion = /OS\s([\d_]+)\s/;

var SCROLL_WIDTH = void 0;

var Main = function (_Component) {
    _inherits(Main, _Component);

    function Main() {
        var _ret;

        _classCallCheck(this, Main);

        var _this = _possibleConstructorReturn(this, (Main.__proto__ || Object.getPrototypeOf(Main)).call(this));

        _this.template = _main2.default;

        _this.resize = function () {
            var h = _this.container.offsetHeight + _this.props.minOffsetBottom,
                w = _this.container.offsetWidth,

            // width - scroll width
            viewPortWidth = _this.root.offsetWidth - _this.scrollWidth,
                viewPortHeight = _this.root.offsetHeight,
                vh = window.innerHeight,
                top = void 0,
                left = void 0;

            // не ставить calc() или процентные значения. хром пересчитывает отступы с погрешностью из-за них
            if (h > vh) {
                top = _this.props.minOffsetTop + 'px';
            } else {
                top = Math.ceil(viewPortHeight / 2 - h / 2) + 'px';
            }

            left = Math.ceil(viewPortWidth / 2 - w / 2) + 'px';

            if (_this.isIOS) {
                top = _this.props.minOffsetTop + 'px';
            }

            if (_this.state.offsetTop !== top || _this.state.offsetLeft !== left) {
                _this.setState({
                    offsetTop: top,
                    offsetLeft: left,
                    minWidth: _this.isIOS ? w : null
                }).then(function () {
                    // при первом появлении попапа нужно дождаться пока установятся начальные оффсеты
                    // только потом показываем попап
                    // иначе он ездит по экрану при установке начальных отступов
                    if (!_this.state.visible) {
                        setTimeout(function () {
                            return _this.setState({ visible: true });
                        }, 150);
                    }
                });
            }

            return _this;
        };

        _this._close = function () {
            if (typeof _this.props.onClose === 'function') {
                _this.props.onClose();
            }

            return _this;
        };

        _this._containerRef = function (el) {
            return _this.container = el;
        };

        _this._rootRef = function (el) {
            return _this.root = el;
        };

        _this.state = {
            offsetTop: null,
            offsetLeft: null,
            visible: false,
            minWidth: null
        };

        SCROLL_WIDTH = SCROLL_WIDTH || (0, _getScrollWidth2.default)();
        _this.scrollWidth = SCROLL_WIDTH;
        _this.isIOS = _this._isIOS();

        return _ret = _this, _possibleConstructorReturn(_this, _ret);
    }

    _createClass(Main, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this._resize();
            this._setDefaultScroll();
            return this;
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            _get(Main.prototype.__proto__ || Object.getPrototypeOf(Main.prototype), 'componentWillUnmount', this).call(this);
            this.resizeInterval && clearInterval(this.resizeInterval);
            return this;
        }
    }, {
        key: '_resize',
        value: function _resize() {
            this.resizeInterval && clearInterval(this.resizeInterval);
            this.resizeInterval = setInterval(this.resize, 50);
            return this;
        }
    }, {
        key: '_setDefaultScroll',
        value: function _setDefaultScroll() {
            if (this.isIOS) {
                window.scrollTo({
                    top: 0,
                    left: 0
                });
            }

            return this;
        }

        // IOS < 11.3 не ресайзит viewport с fixed position при открытии виртуальной клавиатуры, из-за чего
        // ломается расположение элементов на странице
        // TODO REMOVE

    }, {
        key: '_isIOS',
        value: function _isIOS() {
            var ua = window && window.navigator && window.navigator.userAgent;
            var result = false;

            if (iosPattern.test(ua)) {
                var version = iosVersion.exec(ua);

                if (version) {
                    version = version[1].split('_');
                }

                // minor version
                if (version.length >= 2) {
                    result = +version[0] < 11 || +version[1] < 3;
                }
            }

            return result;
        }
    }]);

    return Main;
}(_Component3.default);

Main.defaultProps = {
    closeAvailable: true,
    minOffsetTop: 80,
    minOffsetBottom: 80
};
Main.propTypes = {
    closeAvailable: _propTypes2.default.bool,
    minOffsetTop: _propTypes2.default.number,
    minOffsetBottom: _propTypes2.default.number,
    onClose: _propTypes2.default.func
};
Main.displayName = 'PopupBase';
exports.default = (0, _theme2.default)(Main, 'popup');